var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-lx",
    _vm._b(
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.dialogLoading,
            expression: "dialogLoading",
          },
        ],
        on: { saveClick: _vm.planModify },
      },
      "dialog-lx",
      _vm.dialogData,
      false,
      true
    ),
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("planLxDetail.LXMC"), prop: "planName" } },
            [
              _c("el-input", {
                attrs: { maxlength: 22, size: "small" },
                model: {
                  value: _vm.ruleForm.planName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "planName", $$v)
                  },
                  expression: "ruleForm.planName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("planLxDetail.LXSJ"), prop: "paperName" },
            },
            [
              _c("el-input", {
                attrs: { disabled: "", size: "small" },
                model: {
                  value: _vm.ruleForm.paperName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "paperName", $$v)
                  },
                  expression: "ruleForm.paperName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "el-form-item-time",
              attrs: { label: _vm.$t("planLxDetail.KTSJ"), required: "" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "beginTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          size: "small",
                          "picker-options": _vm.pickerOptions,
                          type: "datetime",
                          placement: "bottom-start",
                          placeholder: _vm.$t("planLxDetail.XZKSRQSJ"),
                        },
                        on: {
                          change: () => {
                            _vm.ruleForm.endTime = ""
                          },
                        },
                        model: {
                          value: _vm.ruleForm.beginTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "beginTime", $$v)
                          },
                          expression: "ruleForm.beginTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticClass: "line",
                  staticStyle: { "text-align": "center" },
                  attrs: { span: 2 },
                },
                [_vm._v("-")]
              ),
              _c(
                "el-col",
                { attrs: { span: 11 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "small",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "picker-options": _vm.pickerOptions,
                          type: "datetime",
                          placement: "bottom-start",
                          placeholder: _vm.$t("planLxDetail.XZJSRQSJ"),
                        },
                        model: {
                          value: _vm.ruleForm.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "endTime", $$v)
                          },
                          expression: "ruleForm.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("planLxDetail.DCSJ"), prop: "perTime" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "6",
                  placeholder: _vm.$t("planLxDetail.FZ"),
                  size: "small",
                },
                model: {
                  value: _vm.ruleForm.perTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "perTime", _vm._n($$v))
                  },
                  expression: "ruleForm.perTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: [["teacher"], "pro"],
                  expression: "[['teacher'], 'pro']",
                },
              ],
              attrs: { label: _vm.$t("planLxDetail.KFCJ"), prop: "scoreFlag" },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.scoreFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "scoreFlag", $$v)
                    },
                    expression: "ruleForm.scoreFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.S"))),
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.F"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: [["teacher"], "pro"],
                  expression: "[['teacher'], 'pro']",
                },
              ],
              staticClass: "el-form-item-time",
              attrs: { "label-width": "0" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("planLxDetail.LXCS"),
                            prop: "rule",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.ruleForm.rule,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "rule", $$v)
                                },
                                expression: "ruleForm.rule",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s(_vm.$t("planLxDetail.DC"))),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("planLxDetail.XH"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.ruleForm.rule === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("planLxDetail.CZCS"),
                                prop: "resetTimes",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  maxlength: "3",
                                  placeholder: _vm.$t(
                                    "planLxDetail.QSRXSKCZCS"
                                  ),
                                },
                                model: {
                                  value: _vm.ruleForm.resetTimes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "resetTimes", $$v)
                                  },
                                  expression: "ruleForm.resetTimes",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isTeamMemberCount
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("planLxDetail.TDCYSL"),
                    prop: "teamMemberCount",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("planLxDetail.QSRSZ"),
                      onkeyup:
                        "value=value.replace(/[^0-9]/g,'');if(value>99){value=99};if(String(value)==='0'){value=1}",
                      size: "small",
                    },
                    model: {
                      value: _vm.ruleForm.teamMemberCount,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "teamMemberCount", $$v)
                      },
                      expression: "ruleForm.teamMemberCount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.pattern_lx == 0
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("createExercise.WJGX"),
                    prop: "isOpenFile",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm.isOpenFile,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "isOpenFile", $$v)
                        },
                        expression: "ruleForm.isOpenFile",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("createExercise.KQ"))),
                      ]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("createExercise.GB"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("createExercise.FZTM"),
                prop: "isOpenPaperCopy",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.isOpenPaperCopy,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "isOpenPaperCopy", $$v)
                    },
                    expression: "ruleForm.isOpenPaperCopy",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("createExercise.KQ"))),
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("createExercise.GB"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: [["teacher"], "pro"],
                  expression: "[['teacher'], 'pro']",
                },
              ],
              attrs: { label: _vm.$t("planLxDetail.DAMS"), prop: "answerFlag" },
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small", disabled: !_vm.ruleForm.scoreFlag },
                  model: {
                    value: _vm.ruleForm.answerFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "answerFlag", $$v)
                    },
                    expression: "ruleForm.answerFlag",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.JJKF"))),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.DTKF"))),
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("planLxDetail.GB"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }